import { render, staticRenderFns } from "./NewTale.vue?vue&type=template&id=b54cc6a0&"
import script from "./NewTale.vue?vue&type=script&lang=js&"
export * from "./NewTale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports